module.exports = ['$timeout', 'notificationsService', scrollToTopWhenDirective];

function scrollToTopWhenDirective($timeout, notifications) {

  return {
    restrict: 'A',
    link: function (scope, element, attrs) {

      var eventNames = attrs.scrollToTopWhen.split(/,\s?/)
      
      _.forEach(eventNames, (eventName) => {
        notifications.subscribe(eventName, scrollElementToTop);
        scope.$on('$destroy', function() {
          notifications.unsubscribe(eventName, scrollElementToTop);
        });
      });

      function scrollElementToTop() {
        $timeout(() => {
          element[0].scrollTop = 0;
        });
      }
    }
  }


}